/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>申请列表 
    <el-button size="small" type="success" @click="addPosition" slot="right" class="ml-auto" v-if="storeInfo.level==3&&storeInfo.type==2">添加企业</el-button>
    </public-title>
      <div class="activ">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="activeName">
            <el-tab-pane  name="2">
            <label slot="label" class="pointer">加入申请
              <span class="unread-msg grey"  v-if=" info.status_2 > 0">{{ info.status_2||0 }}</span>
            </label>
            </el-tab-pane>
            <el-tab-pane label="解除申请" name="4">
              <label slot="label" class="pointer">解除申请
                <span class="unread-msg grey"  v-if=" info.status_4 > 0">{{ info.status_4||0 }}</span>
              </label>
            </el-tab-pane>
            <el-tab-pane label="已解除" name="5"></el-tab-pane>
            <el-tab-pane label="已拒绝" name="3"></el-tab-pane>
        </el-tabs>
      </div>
    <div class="load-area"  v-loading="loading">
      <p v-if="salesAssociationLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head">
          <li class="w-50" v-if="isAdmin">企业名称</li>
          <li class="w-50" v-if="isAdmin">身份</li>
          <template  v-for="item in titleArr">
            <li :class="item.width" :key="item.name" v-if="!$GFUN.isInArray(item.show,activeName)">
              {{item.name}}
            </li>
          </template>
        </ul>
        <ul class="list-item"  v-for="Itemize in salesAssociationLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col" v-if="isAdmin">{{Itemize.title}}</li>
          <li class="w-50 list-item-col" v-if="isAdmin">{{Itemize.store_type==2?'采购商':'供应商'}}</li>
          <li class="w-50 list-item-col">{{Itemize.truename}}<span v-if="Itemize.position_name"> ({{Itemize.position_name}})</span></li>
          <li class="w-50 list-item-col">{{Itemize.mobile}}</li>
          <li class="w-50 list-item-col" v-if="activeName!=1">{{Itemize.add_time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col"> 
             <div class="rimary" :class="$GFUN.correlationColor(Itemize.status)">{{Itemize.status  | formatVar('AssociatedState')}}</div>
          </li>
          <li  class="w-30 list-item-col-end" v-if="$GFUN.isInArray([2,4],activeName)">
            <el-button type="primary" @click="deleteItem(Itemize,1)" size="mini">申请通过</el-button>
            <el-button type="danger" @click="deleteItem(Itemize,2)" size="mini">申请拒绝</el-button>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="salesAssociationLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.currentPage=v"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'Lists',
    computed: {
      ...mapState(['salesAssociationLists','positionDetail','userLoginMessage','waitVerify']),
      ...mapGetters(['storeInfo','isGroup','userInfo','isAdmin']),
       queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getLists()},
      //有新的加入申请消息-刷新列表-
      newMessageInform (newVal) {
        if (newVal && newVal.type === 50) {
          this.getLists();
        }
      },
      currentPage() { this.$router.push({name:this.$route.name,query:{...this.queryCon,page:this.currentPage}}) }
    },
    data() {
      return {
        titleArr:[
          {name:'姓名',width:'w-50'},
          {name:'手机号',width:'w-50'},
          {name:'申请时间',width:'w-50'},
          {name:'状态',width:'w-50'},
          {name:'操作',width:'w-30',show:[3,5]},
        ],
        currentPage:1,
        PopArr: [],
        defaultProps: {
          children: 'children',
          label: 'title'
        },
        activeName:'2',             //当前tab值
        loading: false,
        info:{},                   //关联记录数量
      }
    },
    mounted() {
      this.activeName = `${this.queryCon.status || '2'}`;
      console.log(this.activeName);
      this.getLists();
    },
    methods:{
      ...mapActions([,'POST_UnionRecordList','POST_UnionRecordEnterpriseList','POST_UnionPass','POST_UnionReject','getUserIndexData']),
      // 切换酒店Tab
      handleClick (e) {
        this.activeName = e.name;
        this.$router.push({name:this.$route.name,query:{status:this.activeName}})
        this.getLists();
      },
      getLists() {
        let data = {
          status:this.activeName,
          page:this.currentPage,
          ...this.queryCon,
        }
        this.loading = true;
        this.POST_UnionRecordList({data,successFun:(res)=>{
          this.info = res.info || {};
          this.loading = false;
        }});
      },
      //跳转到编辑职位
      deleteItem(item,i) {
        switch (i) {
          //申请关联通过-解除关联申请通过
          case 1:
          this.POST_UnionPass({data: {union_id:item.id},type:this.activeName,
            successFun: () => {
              this.$message.success('操作成功');
              this.getLists();
              this.getUserIndexData();
            },
          });
          break;
          //申请关联拒绝-解除关联申请拒绝
          case 2:
          this.POST_UnionReject({data: {union_id:item.id},type:this.activeName,
            successFun: () => {
              this.$message.success('操作成功');
              this.getLists();
              this.getUserIndexData();
            },
          });
        }
        
      },
      //添加企业
      addPosition() {
        this.$router.push({name:'PositionAdd',query:{type:2,pid:this.positionDetail.id}})
      }
    },
  }
</script>

<style lang="scss" scoped>
      .activeName  {
        background-color: #fff;
        float: left;
    }
    .activ{
        overflow: hidden;
    }
.scroll{
  min-height: 45px;
  max-height: 50vh
}
.view-box{
  border: 1px solid red
}
.ntm{
  float: left;
}
.fls{
  float: left;
}
.nnsp{
  overflow: hidden;
}
</style>